// extracted by mini-css-extract-plugin
export default {"cancellationCell":"NotesCard_cancellationCell__DOBxs"};